export const currency = (value: number, withDigits: boolean = false) =>
    new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: withDigits ? 2 : 0,
        maximumFractionDigits: withDigits ? 2 : 0
    }).format(value);

export const toSentence = function(array: string[]) {
    const separator = ', ';
    const lastSeparator =  ' and ';
    const a = array.slice(),
        lastMember = a.pop();

    return a.length ? a.join(separator) + lastSeparator + lastMember : lastMember;
};